/* Peak concurrent capital — the most capital simultaneously deployed.
   Sweep-line over entry/exit events: +capital at entry time, -capital at exit
   time (open trades count until "now"). At identical timestamps exits are
   processed BEFORE entries, so a trade taken right after another closed does
   not count as overlapping. Simplification: a trade holds its full entry
   capital until it closes (partial tier releases are ignored). */

export function peakConcurrentCapital(trades) {
  const events = [];
  for (const t of trades) {
    const cap = t.capital;
    if (!cap || !t.time) continue;
    const start = Date.parse(t.time);
    if (isNaN(start)) continue;
    let end = t.exitTime ? Date.parse(t.exitTime) : Date.now();
    if (isNaN(end) || end < start) end = start;
    events.push({ ts: start, delta: +cap });
    events.push({ ts: end, delta: -cap });
  }
  // exits (-) before entries (+) at the same timestamp
  events.sort((a, b) => a.ts - b.ts || a.delta - b.delta);
  let cur = 0, peak = 0, peakTs = null;
  for (const e of events) {
    cur += e.delta;
    if (cur > peak) { peak = cur; peakTs = e.ts; }
  }
  return { peak: Math.round(peak), at: peakTs ? new Date(peakTs) : null };
}

/* Per-day peaks: group trades by entry date (local) and sweep each day.
   Returns [{day, peak}] sorted by day, plus the overall max. */
export function dailyPeakCapital(trades) {
  const byDay = {};
  for (const t of trades) {
    if (!t.capital || !t.time) continue;
    const d = new Date(t.time);
    if (isNaN(d)) continue;
    const day = d.toLocaleDateString("en-CA");
    (byDay[day] = byDay[day] || []).push(t);
  }
  const days = Object.keys(byDay).sort().map(day => ({
    day, peak: peakConcurrentCapital(byDay[day]).peak,
  }));
  const max = days.reduce((a, r) => (r.peak > (a?.peak || 0) ? r : a), null);
  return { days, max };
}
